<div [hidden]="(splashScreen$ | async) && isLoading">
	<ng-template #content></ng-template>
</div>
<wds-snackbar-v3 />
<obg-m-splash-screen *ngIf="(splashScreen$ | async) && isLoading" (loaded)="isLoading = false"></obg-m-splash-screen>
<site-cta_modal
	*ngIf="ctaModalEnabledRoute$ | async as ctaModalEnabledRoute"
	[routeName]="ctaModalEnabledRoute"
></site-cta_modal>
<fds-dialog></fds-dialog>
<fds-snackbar></fds-snackbar>
